module.exports = global["m"] = require("-!./mithril.js");